import React from "react";
import "./toolbar.css";

import Sun from "../../../../images/icons/sun.png";
import Moon from "../../../../images/icons/moon.png";
import InstagramLogo from "../../../../images/icons/instagram.png";
import LocationLogo from "../../../../images/icons/location.png";

import { useTheme } from "../../../../contexts/ThemeContext";

export default function Toolbar() {
  const { toggleTheme, theme } = useTheme();
  return (
    <div className="menu-toolbar">
      <div className="menu-theme-toggler" onClick={toggleTheme}>
        {theme === "dark" ? (
          <img src={Sun} alt="" className="theme-sun-icon" />
        ) : (
          <img src={Moon} alt="" className="theme-moon-icon" />
        )}
      </div>
      <a
        className="toolbar-icon-instagram"
        href="https://instagram.com/redfoxcafe.ir?igshid=YmMyMTA2M2Y="
      >
        <img src={InstagramLogo} alt="" />
      </a>
      <a
        className="toolbar-icon-location"
        href="https://goo.gl/maps/YZuPHed7S59u1FgX6"
      >
        <img src={LocationLogo} alt="" />
      </a>
    </div>
  );
}
